import { CubeTimeDimensionGranularity, AppGoalsCubeMetric } from "../../../enum/cube-schema.enum";
import { CoreScoreNames } from "../../../enum/score-name-cube.enum";
import { IGoalOperator } from "../../../enum/working-days-analytics-activity.enum";


export class GoalDto {
    startDate: string;
    endDate: string;
    scoreName?: CoreScoreNames;
    appId?: string;
    period: CubeTimeDimensionGranularity;
    measure?: AppGoalsCubeMetric;
    operator: IGoalOperator;
    value: string;
}